'use strict';

angular.module('forgot', [
    'ui.router',
]);
